module.exports = __webpack_public_path__ + "static/media/Ogg-Bold.2644e307.woff";